import makeStyles from "@mui/styles/makeStyles";
import lotusIcon from "images/icons/lotus.svg";

const useStyles = makeStyles((theme) => ({
    icon: {
        marginRight: theme.spacing(2),
    },
}));

export interface IconWithinButtonProps {
    icon?: string;
    iconHeight?: number;
}

export const IconWithinButton = (props: IconWithinButtonProps) => {
    const classes = useStyles();

    const iconHeight = props.iconHeight ?? 35;

    return (
        <img height={iconHeight} className={classes.icon} src={props.icon || lotusIcon} alt="" />
    );
};
